import { Injectable } from "@angular/core";
import { Router, NavigationExtras, NavigationStart, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { firstValueFrom, map, race, timer } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class EnhancedRouterService {
    public isForceNavigating = false;

    constructor(private router: Router) { }

    initialize(): void { }

    //Forces navigation by first redirecting to a temporary route.
    //Useful for reloading current routes
    async forceNavigate(commands: any[], extras?: NavigationExtras): Promise<void> {
        this.isForceNavigating = true;

        await this.router.navigateByUrl("/", { skipLocationChange: true });

        const navigationSuccessful = await firstValueFrom(
            race(
                this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(() => true)),
                timer(500).pipe(map(() => false))
            )
        );

        if (!navigationSuccessful) {
            this.isForceNavigating = false;
            return;
        }

        await this.router.navigate(commands, extras);
        this.isForceNavigating = false;
    }
}
